import {
  CloudIcon,
  SunIcon,
  ChartBarIcon,
  CircleStackIcon,
  BeakerIcon,
  SparklesIcon,
  ExclamationTriangleIcon
} from '@heroicons/react/24/outline';
import { t } from '../i18n';

export const weatherAgronomyModules = [
  {
    id: 'weather-data',
    title: t('nav_weather_data'),
    description: '短期天气、预报与趋势',
    icon: CloudIcon,
    path: '/weather-agronomy/weather-data'
  },
  {
    id: 'local-climate',
    title: t('nav_local_climate'),
    description: '多年气候画像与历史气候特征',
    icon: SunIcon,
    path: '/weather-agronomy/local-climate'
  },
  {
    id: 'disaster-warning',
    title: t('nav_disaster_warning') || '灾害预警',
    description: '极端气候与灾害预警列表',
    icon: ExclamationTriangleIcon,
    path: '/weather-agronomy/disaster-warning'
  },
  {
    id: 'intervention-plans',
    title: '干预建议',
    description: '基于气象风险的田间干预与应对建议',
    icon: ChartBarIcon,
    path: '/weather-agronomy/intervention-plans'
  },
  {
    id: 'planting-advice',
    title: t('nav_planting_advice'),
    description: '基于气候条件的智能种植建议与收益预测',
    icon: SparklesIcon,
    path: '/weather-agronomy/planting-advice'
  },
  {
    id: 'soil-analysis',
    title: '土壤依据',
    description: '土壤类型、墒情与种植适宜性分析',
    icon: CircleStackIcon,
    path: '/weather-agronomy/soil-analysis'
  },
  {
    id: 'water-resources',
    title: '水情依据',
    description: '水资源可用性、灌溉与用水约束分析',
    icon: BeakerIcon,
    path: '/weather-agronomy/water-resources'
  }
];

/** 固定顺序：气象监测 → 决策建议 → 资源依据 */
export const weatherAgronomyGroups = [
  {
    id: 'monitor',
    title: '气象监测',
    path: '/weather-agronomy/weather-data',
    moduleIds: ['weather-data', 'local-climate', 'disaster-warning']
  },
  {
    id: 'decision',
    title: '决策建议',
    path: '/weather-agronomy/intervention-plans',
    moduleIds: ['intervention-plans', 'planting-advice']
  },
  {
    id: 'resource',
    title: '资源依据',
    path: '/weather-agronomy/soil-analysis',
    moduleIds: ['soil-analysis', 'water-resources']
  }
];

export function matchWeatherAgronomyModule(item, pathname) {
  if (!item?.path || !pathname) return false;
  if (pathname === item.path) return true;
  if (item.path.startsWith('/weather-agronomy/') && pathname.startsWith(`${item.path}/`)) {
    return true;
  }
  return false;
}

export function findWeatherAgronomyModule(pathname) {
  return weatherAgronomyModules.find((item) => matchWeatherAgronomyModule(item, pathname)) || null;
}

export function findWeatherAgronomyGroup(pathname) {
  const mod = findWeatherAgronomyModule(pathname);
  if (!mod) return null;
  return weatherAgronomyGroups.find((g) => g.moduleIds.includes(mod.id)) || null;
}

export function getWeatherAgronomyGroupModules(group) {
  if (!group) return [];
  const byId = Object.fromEntries(weatherAgronomyModules.map((m) => [m.id, m]));
  return group.moduleIds.map((id) => byId[id]).filter(Boolean);
}
